/* @ngInject */

export default (ProductFee, dateTimeService, ASSET_FINANCE) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function Product(
    id,
    abbr,
    name,
    notes,
    type,
    mod,
    lender,
    residential,
    homeLoanEstimate,
    assetFinance,
    assetFinanceEstimate,
    fee,
    dcb,
    acm,
    gateway,
    reward,
    isActive
  ) {
    this.id = id;
    this.abbr = abbr;
    this.name = name;
    this.notes = notes;
    this.type = type;
    this.mod = mod;
    this.lender = lender;
    this.residential = residential;
    this.homeLoanEstimate = homeLoanEstimate;
    this.assetFinance = assetFinance;
    this.assetFinanceEstimate = assetFinanceEstimate;
    this.fee = fee;
    this.dcb = dcb;
    this.acm = acm;
    this.gateway = gateway;
    this.reward = reward;
    this.isActive = isActive;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  Product.Blank = function () {
    return Product.Build({
      id: '',
      abbr: '',
      name: '',
      notes: '',
      type: '',
      mod: '',
      lender: [],
      residential: {
        type: '',
        rateType: '',
        repaymentType: '',
        propertyUse: '',
        baseInitialRate: 0,
        initialRate: 0,
        discountInitialRate: 0,
        baseRevertRate: 0,
        revertRate: 0,
        discountRevertRate: 0,
        comparisonRate: 0,
        lvrMin: 0,
        lvrMax: 0,
        loanMin: 0,
        loanMax: 0,
        termMax: 0,
        fixedTerm: 0,
        introTerm: 0,
        ioMaxPeriod: 0,
        ioMinPeriod: 0,
        proPackDiscount: 0,
        proPack: '',
        smsf: '',
        creditImpaired: '',
        whiteLabel: '',
        lineOfCredit: '',
        construction: '',
        lmiCapitalization: '',
        lmiRequiredOver: '',
        redrawFacility: '',
        additionalRepayments: '',
        offset: '',
        splitLoan: ''
      },
      homeLoanEstimate: [],
      assetFinance: {
        products: [],
        vendors: [],
        loans: [],
        consumer: false,
        assetTypeLender: '',
        assetType: [],
        loanMin: 0,
        loanMax: 0,
        assetAgeMin: 0,
        assetAgeMax: 0,
        assetAgeEot: 0,
        termMin: 0,
        termMax: 0,
        brokerageMin: 0,
        brokerageMax: 0,
        brokerageValueMin: 0,
        brokerageValueMax: 0,
        rateDiscountMin: 0,
        rateDiscountMax: 0,
        lvrMin: 0,
        lvrMax: 0,
        balloonMin: 0,
        balloonMax: 0,
        rateBase: 0,
        rateMax: 0,
        abnMin: 0,
        abnMax: 0,
        gstMin: 0,
        gstMax: 0,
        creditHistory: [],
        creditReference: [],
        homeOwnership: [],
        employmentBasis: [],
        timeAtCurrentAddress: [],
        timeInEmployment: [],
        originationFeeMax: 0,
        hasOverrideDocumentFee: false,
        advance: false,
        arrears: false,
        paygAndNoAbn: [],
        assessmentRate: 0,
        assessmentRateBuffer: 0,
        creditScoreMin: 0,
        creditScoreMax: 0,
        documentFeePercent: 0,
        elapsedTimeFromPayout: [],
        elapsedTermOldLoan: [],
        payDayEnquires: [],
        payDayOnStatements: [],
        increaseInRepayment: [],
        maxNegativeEquity: [],
        ritc: 0,
        brokerCommission: 0,
        changeToEntity: [],
        bankrupts: [],
        utilityAndTelCo: [],
        financialDefaults: [],
        financedFees: [],
        financedInsurance: [],
        borrowerOnVisa: [],
        likeForLike: [],
        depositRequired: []
      },
      assetFinanceEstimate: [],
      fee: [],
      dcb: [],
      acm: [],
      gateway: [],
      reward: [],
      isActive: true
    });
  };
  Product.Build = function (data) {
    return new Product(
      data.id ? data.id : '',
      data.abbr ? data.abbr : '',
      data.name ? data.name : '',
      data.notes ? data.notes : '',
      data.type ? data.type : '',
      data.mod ? data.mod : '',
      data.lender ? data.lender : [],
      data.residential
        ? data.residential
        : {
            type: '',
            rateType: '',
            repaymentType: '',
            propertyUse: '',
            baseInitialRate: 0,
            initialRate: 0,
            discountInitialRate: 0,
            baseRevertRate: 0,
            revertRate: 0,
            discountRevertRate: 0,
            comparisonRate: 0,
            lvrMin: 0,
            lvrMax: 0,
            loanMin: 0,
            loanMax: 0,
            termMax: 0,
            fixedTerm: 0,
            introTerm: 0,
            ioMaxPeriod: 0,
            ioMinPeriod: 0,
            proPackDiscount: 0,
            proPack: '',
            smsf: '',
            creditImpaired: '',
            whiteLabel: '',
            lineOfCredit: '',
            construction: '',
            lmiCapitalization: '',
            lmiRequiredOver: '',
            redrawFacility: '',
            additionalRepayments: '',
            offset: '',
            splitLoan: ''
          },
      data.homeLoanEstimate ? data.homeLoanEstimate : [],
      data.assetFinance
        ? data.assetFinance
        : {
            products: [],
            vendors: [],
            loans: [],
            consumer: false,
            assetTypeLender: '',
            assetType: [],
            loanMin: 0,
            loanMax: 0,
            assetAgeMin: 0,
            assetAgeMax: 0,
            assetAgeEot: 0,
            termMin: 0,
            termMax: 0,
            brokerageMin: 0,
            brokerageMax: 0,
            brokerageValueMin: 0,
            brokerageValueMax: 0,
            rateDiscountMin: 0,
            rateDiscountMax: 0,
            lvrMin: 0,
            lvrMax: 0,
            balloonMin: 0,
            balloonMax: 0,
            rateBase: 0,
            rateMax: 0,
            abnMin: 0,
            abnMax: 0,
            gstMin: 0,
            gstMax: 0,
            creditHistory: [],
            creditReference: [],
            homeOwnership: [],
            employmentBasis: [],
            timeAtCurrentAddress: [],
            timeInEmployment: [],
            originationFeeMax: 0,
            hasOverrideDocumentFee: false,
            advance: false,
            arrears: false,
            paygAndNoAbn: [],
            assessmentRate: 0,
            assessmentRateBuffer: 0,
            creditScoreMin: 0,
            creditScoreMax: 0,
            documentFeePercent: 0,
            elapsedTimeFromPayout: [],
            elapsedTermOldLoan: [],
            payDayEnquires: [],
            payDayOnStatements: [],
            increaseInRepayment: [],
            maxNegativeEquity: [],
            ritc: 0,
            brokerCommission: 0,
            changeToEntity: [],
            bankrupts: [],
            utilityAndTelCo: [],
            financialDefaults: [],
            financedFees: [],
            financedInsurance: [],
            borrowerOnVisa: [],
            likeForLike: [],
            depositRequired: []
          },
      data.assetFinanceEstimate ? data.assetFinanceEstimate : [],
      _.map(_.compact(data.fee), (f) => ProductFee.Build(f)),
      data.dcb ? data.dcb : [],
      data.acm ? data.acm : [],
      data.gateway ? data.gateway : [],
      data.reward ? data.reward : [],
      data.isActive ? data.isActive : true
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  Product.prototype.getName = function () {
    return this.name;
  };
  Product.prototype.getNotes = function () {
    return this.notes || 'N/A';
  };
  Product.prototype.getLenderName = function () {
    return this?.lender[0]?.name || 'N/A';
  };
  Product.prototype.getFee = function (type) {
    const fees = this.fee;
    const fee = _.find(fees, (f) => f.type.toLowerCase() === type);
    return fee ? parseFloat(fee.value || 0) : 0;
  };
  Product.prototype.getApplicationFee = function () {
    return this.getFee('application');
  };
  Product.prototype.getUpfrontFee = function () {
    return this.getFee('upfront');
  };
  Product.prototype.getRateLockFee = function () {
    return this.getFee('rate_lock');
  };
  Product.prototype.getPackageMonthlyFee = function () {
    return this.getFee('monthly');
  };
  Product.prototype.getPackageAnnualFee = function () {
    return this.getFee('yearly');
  };
  Product.prototype.getValuationFee = function () {
    return this.getFee('valuation');
  };
  Product.prototype.getSettlementFee = function () {
    return this.getFee('settlement');
  };
  Product.prototype.getLegalFee = function () {
    return this.getFee('legal');
  };
  Product.prototype.getOtherFee = function () {
    let total = 0;
    const fees = this.fee;
    for (let i = 0; i < fees.length; i += 1) {
      if (fees[i].type.toLowerCase() === 'other') {
        total += parseFloat(fees[i].value || 0);
      }
    }
    return total;
  };
  Product.prototype.getInterestRate = function () {
    return this.residential.initialRate;
  };
  Product.prototype.getBaseInterestRate = function () {
    return this.residential.baseInitialRate;
  };
  Product.prototype.getInterestRateDiscount = function () {
    return this.residential.discountInitialRate;
  };
  Product.prototype.getRevertRate = function () {
    return this.residential.revertRate;
  };
  Product.prototype.getBaseRevertRate = function () {
    return this.residential.baseRevertRate;
  };
  Product.prototype.getRevertRateDiscount = function () {
    return this.residential.discountRevertRate;
  };
  Product.prototype.getComparisonRate = function () {
    return this.homeLoanEstimate[0]?.product?.productSplits[0]?.comparisonRate || 0;
  };
  Product.prototype.getMaximumBorrowing = function () {
    return this.homeLoanEstimate[0]?.product?.productSplits[0]?.maximumBorrowing || 0;
  };
  Product.prototype.getNetMonthlySurplus = function () {
    return this.assetFinanceEstimate[0]?.product?.netMonthlySurplus || 0;
  };
  Product.prototype.getAssetFinanceTotalCosts = function () {
    return this.assetFinanceEstimate[0]?.product?.totalCosts || 0;
  };
  Product.prototype.getHomeLoanTotalCosts = function () {
    return this.homeLoanEstimate[0]?.product?.totalCosts || 0;
  };
  Product.prototype.getRepaymentType = function () {
    let repaymentType = '';
    if (this.residential.repaymentType === 'PI') {
      repaymentType = 'Principal and interest';
    }
    if (this.residential.repaymentType === 'IO') {
      repaymentType = 'Interest only';
    }
    if (this.residential.repaymentType === 'IOA') {
      repaymentType = 'Interest only in advance';
    }
    return repaymentType;
  };
  Product.prototype.getAssetFinanceInterestRate = function () {
    return this.assetFinance.rateBase;
  };
  Product.prototype.getCurrentAssetFinanceInterestRate = function () {
    return this.assetFinance.rateBase > 0
      ? `${this.assetFinance.rateBase.toFixed(2)}%`
      : 'Refer to lender';
  };
  Product.prototype.getAssetTypes = function () {
    const { assetType } = this.assetFinance;
    const assetTypeNames = _.map(
      _.filter(
        ASSET_FINANCE.DETAILS.ASSET_TYPE,
        (s) => s.searchField && assetType.indexOf(s.searchField) > -1
      ),
      (a) => a.value
    );
    return assetTypeNames.length ? assetTypeNames.join(', ') : '';
  };
  Product.prototype.getProductTypes = function () {
    const productType = this.assetFinance.products;
    const productTypeNames = _.map(
      _.filter(
        ASSET_FINANCE.DETAILS.PRODUCT_TYPE,
        (s) => s.searchField && productType.indexOf(s.searchField) > -1
      ),
      (a) => a.value
    );
    return productTypeNames.length ? productTypeNames.join(', ') : '';
  };
  Product.prototype.getVendorTypes = function () {
    const vendorType = this.assetFinance.vendors;
    const vendorTypeNames = _.map(
      _.filter(
        ASSET_FINANCE.DETAILS.VENDOR_TYPE,
        (s) => s.searchField && vendorType.indexOf(s.searchField) > -1
      ),
      (a) => a.value
    );
    return vendorTypeNames.length ? vendorTypeNames.join(', ') : '';
  };
  Product.prototype.getDate = function () {
    return dateTimeService.getFormattedDate(this.timeStamp);
  };
  Product.prototype.getTime = function () {
    return dateTimeService.getFormattedTime(this.timeStamp);
  };

  return Product;
};
